var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ButtonPrimary',{staticClass:"trade-search__button",attrs:{"background":_vm.NebraskaColors.themePrimary,"label":_vm.label},on:{"click":_vm.goToSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }